import React from 'react'
import { Link } from 'react-router-dom'
import AdmiSubHeader from '../../components/subheader/admi-subheader.components'
import { AdmiMenu } from './admi-menu.components'
import './admi.styles.scss'

const cards = [
  {
    title: 'Inquiries',
    copy: 'Read customer messages and send replies.',
    to: '/inquiry',
    cta: 'Open inquiries',
  },
  {
    title: 'Orders',
    copy: 'Review booking requests and update status.',
    to: '/orders',
    cta: 'Open orders',
  },
  {
    title: 'Pages',
    copy: 'Edit home, about, and gallery content.',
    to: '/pages',
    cta: 'Open pages',
  },
  {
    title: 'Settings',
    copy: 'Company details, hours, and Staff/Users.',
    to: '/settings',
    cta: 'Open settings',
  },
]

const ManageHome = () => {
  return (
    <div className="admin-shell">
      <AdmiSubHeader h2="Manage" h6="Staff tools for Cake by Sandy" />
      <AdmiMenu />

      <div className="admin-shell__body">
        <div className="admin-shell__intro">
          <p className="admin-shell__eyebrow">Kitchen desk</p>
          <h3>What do you need today?</h3>
          <p>Pick a section below. Only staff accounts can open these pages.</p>
        </div>

        <div className="admin-shell__grid">
          {cards.map((card) => (
            <Link key={card.to} to={card.to} className="admin-shell__card">
              <h4>{card.title}</h4>
              <p>{card.copy}</p>
              <span>{card.cta}</span>
            </Link>
          ))}
        </div>

        <p className="admin-shell__note">
          Tip: after a customer submits Contact or Book, check Inquiries and Orders here.
        </p>
      </div>
    </div>
  )
}

export default ManageHome
